import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLayoutRight"><Path d="M15.5 3C16.8807 3 18 4.11929 18 5.5V18.5C18 19.8807 16.8807 21 15.5 21H5.5C4.11929 21 3 19.8807 3 18.5V5.5C3 4.11929 4.11929 3 5.5 3H15.5Z" fill="currentColor"/><Path d="M20.5 3C20.7761 3 21 3.22386 21 3.5V20.5C21 20.7761 20.7761 21 20.5 21C20.2239 21 20 20.7761 20 20.5V3.5C20 3.22386 20.2239 3 20.5 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutRight;
